import React from "react";
import Banner2 from "../assets/images/Banners/1200x400/Bigmall_Electronics-Recovered.png";
import Banner3 from "../assets/images/Banners/1200x400/Bigmall_Hardware-Recovered.png";
import Banner4 from "../assets/images/Banners/1200x400/Bigmall_Kitchen Appliences.png";
import Banner5 from "../assets/images/Banners/1200x400/Bigmall_Snacks-Recovered.png";
//import Banner6 from "../assets/images/Banners/2100x500/test.webp";
//import Banner7 from "../assets/images/Banners/2100x500/test2.png";
// Default images in case no banners are available
const defaultImages = [
  {
    src: Banner2,
    alt: "Banner 2",
    url: "/",
  },
  {
    src: Banner3,
    alt: "Banner 3",
    url: "/",
  },
  {
    src: Banner4,
    alt: "Banner 4",
    url: "/",
  },
  {
    src: Banner5,
    alt: "Banner 5",
    url: "/",
  },

];

const CustomSlider = ({ banners }) => {
  // Use banners from props if available, otherwise fallback to default images
 const sliderBanners = banners && banners.length > 0 ? banners : defaultImages;
// const sliderBanners =  defaultImages;

  return (
    <div className="mt-5 mb-0">
      <div
        id="customCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        {/* Carousel Indicators */}
        <div className="carousel-indicators">
          {sliderBanners.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#customCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>

        {/* Carousel Items */}
        <div className="carousel-inner">
          {sliderBanners.map((banner, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <div
                className="rounded-3 overflow-hidden"
                style={{ aspectRatio: "2100 / 500" }}
              >
                <a
                  href={banner.url}
                  style={{ display: "block", width: "100%", height: "100%" }}
                >
                  <img
                    src={banner.src}
                    alt={banner.alt}
                    className="d-block w-100 h-100"
                    style={{ objectFit: "cover" }}
                  />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Carousel Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#customCarousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              padding: "1rem",
              borderRadius: "50%",
            }}
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#customCarousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              padding: "1rem",
              borderRadius: "50%",
            }}
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default CustomSlider;
